import { Project } from '../types'

export const projects: Project[] = [
  {
    id: '1',
    title: '2B+G+14+Roof Pool Residential Building',
    category: 'Residential',
    images: [
      '/images/projects/jaddaf-water-1.jpg',
      '/images/projects/jaddaf-water-2.jpg',
      '/images/projects/jaddaf-water-3.jpg',
      '/images/projects/jaddaf-water-4.jpg',
      '/images/projects/jaddaf-water-5.jpg',
      '/images/projects/jaddaf-water-6.jpg',
      '/images/projects/jaddaf-water-7.jpg',
      '/images/projects/jaddaf-water-8.jpg'
    ],
    status: 'Ongoing',
    location: 'Jaddaf Water, Dubai',
    client: 'M/s IRAAZ PROPERTIES',
    consultant: '',
  },
  {
    id: '2',
    title: 'G+M Warehouse @ DIP Plot No:598-399',
    category: 'Commercial',
    images: [
      '/images/projects/dip-warehouse-1.png'
    ],
    status: 'Ongoing',
    location: 'Dubai Investment Park',
    client: 'Mr.JAMAL MOHAMED SALEH ALAQILI ALMARZOOQI',
    consultant: '',
  },
  {
    id: '3',
    title: 'G+5 Hotel Building @ DIP Plot No:598-1344',
    category: 'Commercial',
    images: [
      '/images/projects/hotel-dip-1.jpg'
    ],
    status: 'Ongoing',
    location: 'Dubai Investment Park',
    client: '',
    consultant: '',
  },
  {
    id: '4',
    title: 'G+1 Villa + Boundary Villa Plot No:71111639',
    category: 'Residential',
    images: [
      '/images/projects/al-awir-villa-1.jpg'
    ],
    status: 'Ongoing',
    location: 'Al Awir, Dubai',
    client: '',
    consultant: '',
  },
  {
    id: '5',
    title: 'G+2 Labour Camp Accommodation',
    category: 'Residential',
    images: [
      '/images/projects/labour-camp-1.jpg',
      '/images/projects/labour-camp-2.jpg',
      '/images/projects/labour-camp-3.jpg'
    ],
    status: 'Completed',
    location: 'Dubai',
    client: '',
    consultant: 'ALIGN Engineering Consultants',
  },
  {
    id: '6',
    title: 'Warehouse Project @ DIC',
    category: 'Commercial',
    images: [
      '/images/projects/dic-warehouse-1.jpg',
      '/images/projects/dic-warehouse-2.jpg'
    ],
    status: 'Completed',
    location: 'Dubai Industrial City',
    client: 'Avantgarde Falcons Logistics',
    consultant: 'ALIGN Engineering Consultants',
  },
  {
    id: '7',
    title: 'Villa G + Compound Wall Plot No:  71113398',
    category: 'Residential',
    images: [
      '/images/projects/al-awir-compound-1.jpg'
    ],
    status: 'Completed',
    location: 'Al Awir, Dubai',
    client: 'Mariyam Yousuf Ahamed',
    consultant: 'Adwar Engineering Consultant',
  },
  {
    id: '8',
    title: 'OSR Mall @ Sharjah',
    category: 'Commercial',
    images: [
      '/images/projects/osr-mall-1.png'
    ],
    status: 'Completed',
    location: 'Sharjah',
    client: 'OSR Mall',
    consultant: '',
  },
  {
    id: '9',
    title: 'RB53 G+4+R Residential Building',
    category: 'Residential',
    images: [
      '/images/projects/rb53-1.jpg',
      '/images/projects/rb53-2.jpg',
      '/images/projects/rb53-3.jpg',
      '/images/projects/rb53-4.jpg'
    ],
    status: 'Completed',
    location: 'Dubai',
    client: 'Al Sandos Real Estate LLC',
    consultant: 'M/s  ART Consultant',
  },
  {
    id: '10',
    title: 'RC58 G+4+R Residential Building',
    category: 'Residential',
    images: [
      '/images/projects/rc58-1.jpg',
      '/images/projects/rc58-2.png',
      '/images/projects/rc58-3.jpg'
    ],
    status: 'Completed',
    location: 'Dubai',
    client: 'Al Sandos Real Estate LLC',
    consultant: 'M/s  ART Consultant',
  },
  {
    id: '11',
    title: 'RC11 G+6+R Residential Building',
    category: 'Residential',
    images: [
      '/images/projects/rc11-1.jpg',
      '/images/projects/rc11-2.jpg'
    ],
    status: 'Completed',
    location: 'Dubai',
    client: 'Al Sandos Real Estate LLC',
    consultant: 'M/s  ART Consultant',
  },
  {
    id: '12',
    title: 'G+1 Commercial Villa @ Al Barsha',
    category: 'Commercial',
    images: [
      '/images/projects/al-barsha-villa-1.jpg',
      '/images/projects/al-barsha-villa-2.jpg',
      '/images/projects/al-barsha-villa-3.jpg',
      '/images/projects/al-barsha-villa-4.jpg',
      '/images/projects/al-barsha-villa-5.jpg'
    ],
    status: 'Completed',
    location: 'Al Barsha South, Dubai',
    client: '',
    consultant: '',
  },
  {
    id: '13',
    title: 'G+1 Villa @ Nad Al Sheba',
    category: 'Residential',
    images: [
      '/images/projects/nad-al-sheba-1.jpg',
      '/images/projects/nad-al-sheba-2.jpg',
      '/images/projects/nad-al-sheba-3.jpg',
      '/images/projects/nad-al-sheba-4.jpg',
      '/images/projects/nad-al-sheba-5.jpg'
    ],
    status: 'Completed',
    location: 'Nad Al Sheba, Dubai',
    client: '',
    consultant: '',
  },
  {
    id: '14',
    title: 'B+G+7+HC+R Residential Building @ Wadi Al Safa 3',
    category: 'Residential',
    images: [
      '/images/projects/wadi-al-safa-1.jpg'
    ],
    status: 'Completed',
    location: 'Wadi Al Safa 3, Dubai',
    client: 'BHARI & MAZROEI TRADING CO L.L.C.',
    consultant: '',
  },
  {
    id: '15',
    title: 'G+2P+8 Residential @ Al Satwa',
    category: 'Commercial',
    images: [
      '/images/projects/al-satwa-1.jpg'
    ],
    status: 'Completed',
    location: 'Al Satwa, Dubai',
    client: 'Mr. Ahmed Karim Karimian.',
    consultant: '',
  },
  {
    id: '16',
    title: 'SAMARA VILLAS ARABIAN RANCHES II (G+1) 20 VILLAS)',
    category: 'Residential',
    images: [
      '/images/projects/samara-villas-2.png',
      '/images/projects/samara-villas-1.png',
      '/images/projects/samara-villas-3.png'
    ],
    status: 'Completed',
    location: 'Arabian Ranches 2',
    client: 'EMMAR MALLS GROUP PJSC, DUBAI', 
    consultant: '',
  }
]

export const projectCategories = [
  'All',
  'Ongoing',
  'Completed',
]
